import cx from 'classnames';
import PropTypes from 'prop-types';
import withTheme from 'core/hocs/withTheme';
import withBreakpoint from 'core/hocs/withBreakpoint';
import themePropTypes from 'core/utils/prop-types/theme';
import breakpointPropTypes from 'core/utils/prop-types/breakpoint';
import Image from 'core/components/Image';

import styles from './index.styl';

function Avatar({ theme, breakpoint, src, size, url, isCircular, alt }) {
  const {
    icons: {
      DefaultAvatar,
    },
    controls: {
      avatar: avatarAtoms,
    },
  } = theme;

  const boolCircular = isCircular === undefined ? avatarAtoms.isCircular : isCircular;

  return (
    <div className={cx('avatar', styles.avatar, styles[breakpoint], boolCircular && styles.circular)}>
      <style jsx>{`
        .avatar
          width ${size}px
          height ${size}px
          border ${avatarAtoms.border}
          background ${avatarAtoms.background}
          box-shadow ${avatarAtoms.boxShadow}
          :global(.border)
            fill ${avatarAtoms.svg.border.fill}
            stroke ${avatarAtoms.svg.border.stroke}
          :global(.content)
            fill ${avatarAtoms.svg.content.fill}
            stroke ${avatarAtoms.svg.content.stroke}
      `}</style>
      {(src || url) ? <Image
        width={size}
        src={src}
        aspectRatio={1}
        url={url}
        alt={alt}
      /> : <DefaultAvatar width={size} height={size} />}
    </div>
  );
}

Avatar.defaultProps = {
  size: 60,
};

const svgContract = '{fill, stroke}';

Avatar.propTypes = {
  /**
   * Атрибут, из которого компонент берет URL для изображения,
   * которое будет выведено на экран. Атрибут берется из API.
   */
  src: PropTypes.object,
  /**
   * URL внешнего изображения.
   */
  url: PropTypes.string,
  /**
   * Размер стороны контейнера в пикселях, в который будет вписан аватар
   */
  size: PropTypes.number,
  /** @ignore */
  alt: PropTypes.string,
  theme: themePropTypes(`{
    controls: {
      avatar: {
        isCircular,
        border,
        background,
        boxShadow,
        svg: {
          border:${svgContract},
          content: ${svgContract},
        }
      }
    }
  }`),
  /** @ignore */
  breakpoint: breakpointPropTypes(),
  /**
   * Флаг, позволяющий отобразить скругленный аватар
   */
  isCircular: PropTypes.bool,
};

const AvatarWithHOCs = withTheme(withBreakpoint(Avatar));
AvatarWithHOCs.displayName = 'Avatar';

export { Avatar as StorybookComponent };
export default AvatarWithHOCs;
